import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { class: "col-12" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryRecall',
  setup(__props) {

const { t } = useI18n();

const notificationText = computed(() => {
  return t("messages.bookingRecallSuccessNotification").replace(
    "##NotificationText##",
    t("common.aNotification")
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)("messages.bookingRecallSuccess")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, _toDisplayString(notificationText.value), 1)
    ])
  ]))
}
}

})